import React from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Typography,
	Box,
	Dialog,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	IconButton
} from '@material-ui/core';
import { Close, NewReleases, CheckCircle } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
	contentWrapper: {
		flexDirection: 'column',
		'& .leftPanel': {
			backgroundColor: theme.palette.primary.main,
			overflow: 'hidden',
			position: 'relative',
			paddingTop: theme.spacing(8)
		},
		'& .upgradeImg': {
			marginTop: theme.spacing(4)
		},
		[theme.breakpoints.up('sm')]: {
			flexDirection: 'row',
			'& .upgradeImg': {
				width: '130%',
				position: 'absolute',
				bottom: 0,
				left: '-15%',
				maxWidth: 'initial'
			},
			'& .leftPanel': {
				paddingBottom: '30%'
			}
		}
	},
	leftPanelTitle: {
		color: 'white',
		fontWeight: '500',
		textAlign: 'center',
		fontSize: '2rem'
	},

	listItemIconWrapper: {
		minWidth: 34,
		color: '#7CBF43'
	},
	listIcon: {
		fontSize: '1.6rem'
	},
	featuresTitleText: {
		fontSize: '1.25rem',
		'& b': {
			color: '#D0285C'
		}
	},
	listItemText: {
		fontSize: '1.2rem',
		verticalAlign: 'baseline'
	},
	bonusTag: {
		color: 'white',
		backgroundColor: '#D0285C',
		padding: '3px 12px',
		fontSize: '0.8rem',
		fontWeight: 'bold',
		borderRadius: 12,
		marginLeft: 4
	},
	dffIcon: {
		color: '#D0285C'
	},
	upgradeButton: {
		fontSize: '1.1rem',
		fontWeight: '600'
	},

	closeButton: {
		position: 'absolute',
		right: 0,
		top: 0,
		color: theme.palette.common.white
	}
}));

const LaunchBrandingDialog = ({ open, onClose }) => {
	const classes = useStyles();

	const features = [
		{
			icon: NewReleases,
			iconClass: classes.dffIcon,
			text: (
				<>
					<span>Enhanced Digital Fact Finder </span>
					<span className={classes.bonusTag}>BONUS!</span>
				</>
			)
		},
		'Report Cover Customization',
		'Website Builder',
		'Website Domain',
		'Dashboard Themes'
	];

	const onLaunch = () => {
		console.log('onLaunch');
		window.open(window.PMLink);
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="md">
			<Box display="flex" className={classes.contentWrapper}>
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
					flex={1}
					px={3}
					className="leftPanel"
				>
					<Typography
						gutterBottom
						variant="h4"
						component="h2"
						className={classes.leftPanelTitle}
					>
						Ready to Launch Your Branding?
					</Typography>
					<img
						className="upgradeImg"
						src="https://static.goalsmapper.com/public/platform/branding/banner.svg"
						alt="Branding banner"
					/>
				</Box>
				<Box display="flex" flex={1} flexDirection="column" px={4} py={5}>
					<Box mb={3}>
						<Typography
							variant="body1"
							gutterBottom
							color="textPrimary"
							component="p"
							className={classes.featuresTitleText}
						>
							Upgrade to <b>Suit Up</b> subscription and start customizing right away.
						</Typography>
					</Box>
					<List dense disablePadding>
						{features.map(feature => {
							const Icon = feature.icon || CheckCircle;
							const featureText = feature.text || feature;
							return (
								<ListItem key={`feature-${feature}`} disableGutters dense>
									<ListItemIcon className={classes.listItemIconWrapper}>
										<Icon
											className={classNames(
												classes.listIcon,
												feature.iconClass
											)}
										/>
									</ListItemIcon>
									<ListItemText
										primaryTypographyProps={{ className: classes.listItemText }}
										primary={featureText}
									/>
								</ListItem>
							);
						})}
					</List>
					<Box pt={4}>
						<Button
							onClick={onLaunch}
							fullWidth
							variant="contained"
							className={classes.upgradeButton}
							color="primary"
						>
							Upgrade Now!
						</Button>
					</Box>
				</Box>
			</Box>

			<IconButton onClick={onClose} className={classes.closeButton} aria-label="close">
				<Close />
			</IconButton>
		</Dialog>
	);
};

LaunchBrandingDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};

export default LaunchBrandingDialog;
